/*
 * 
 * 
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.57
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";

/**
* General service.
* @module api/GeneralApi
* @version 1.0.0
*/
export default class GeneralApi {

  /**
  * Constructs a new GeneralApi. 
  * @alias module:api/GeneralApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instanc
  e} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  /**
   * Callback function to receive the result of the getObjects operation.
   * @callback moduleapi/GeneralApi~getObjectsCallback
   * @param {String} error Error message, if any.
   * @param {Object{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод получения списка объектов
   * @param {String} database 
   * @param {String} dataset 
   * @param {Object} opts Optional parameters
   * @param {String} opts.filter  (default to <.>)
   * @param {Number} opts.limit  (default to <.>)
   * @param {Number} opts.skip  (default to <.>)
   * @param {String} opts.sortBy 
   * @param {String} opts.sortOrder 
   * @param {String} opts.projection  (default to <.>)
   * @param {module:api/GeneralApi~getObjectsCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  getObjects(database, dataset, opts, callback) {
    opts = opts || {};
    let postBody = null;
    // verify the required parameter 'database' is set
    if (database === undefined || database === null) {
      throw new Error("Missing the required parameter 'database' when calling getObjects");
    }
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling getObjects");
    }

    let pathParams = {

    };
    let queryParams = {
      'database': database,
      'dataset': dataset,
      'filter': opts['filter'] && JSON.stringify(opts['filter']),
      'limit': opts['limit'],
      'skip': opts['skip'],
      'sortBy': opts['sortBy'],
      'sortOrder': opts['sortOrder'],
      'projection': opts['projection'] && JSON.stringify(opts['projection'])
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;

    return this.apiClient.callApi(
      '/general/objects', 'GET',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }


  getObjectsCount(database, dataset, opts, callback) {
    opts = opts || {};
    let postBody = null;
    // verify the required parameter 'database' is set
    if (database === undefined || database === null) {
      throw new Error("Missing the required parameter 'database' when calling getObjects");
    }
    // verify the required parameter 'dataset' is set
    if (dataset === undefined || dataset === null) {
      throw new Error("Missing the required parameter 'dataset' when calling getObjects");
    }

    let pathParams = {

    };
    let queryParams = {
      'database': database,
      'dataset': dataset,
      'filter': opts['filter'] && JSON.stringify(opts['filter'])     
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;

    return this.apiClient.callApi(
      '/general/objectsCount', 'GET',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }


  /**
   * Callback function to receive the result of the textSearch operation.
   * @callback moduleapi/GeneralApi~textSearchCallback
   * @param {String} error Error message, if any.
   * @param {Object{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод поиска по строке
   * @param {Object} opts Optional parameters
   * @param {String} opts.searchRequest 
   * @param {module:api/GeneralApi~textSearchCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  textSearch(opts, callback) {
    opts = opts || {};
    let postBody = null;

    let pathParams = {

    };
    let queryParams = {
      'searchRequest': opts['searchRequest']
    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;

    return this.apiClient.callApi(
      '/general/textSearch', 'GET',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }
  /**
   * Callback function to receive the result of the userinfo operation.
   * @callback moduleapi/GeneralApi~userinfoCallback
   * @param {String} error Error message, if any.
   * @param {Object{ data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Метод получения информации о пользователе
   * @param {module:api/GeneralApi~userinfoCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
   */
  userinfo(callback) {

    let postBody = null;

    let pathParams = {

    };
    let queryParams = {

    };
    let headerParams = {

    };
    let formParams = {

    };

    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;

    return this.apiClient.callApi(
      '/general/userInfo', 'GET',
      pathParams, queryParams, headerParams, formParams, postBody,
      authNames, contentTypes, accepts, returnType, callback
    );
  }

}